module.exports = __webpack_public_path__ + "static/4-d1b76bf53ec41fb1cca4082be989afad.png";